import React, { useState } from "react"
import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../../common/Modal';
import OtherProductsList from "./otherProductsList";

const OtherProductsListModal = (props) => {
    const { otherProductsList, showDialog, toggleDialog, bsClass, modalTitle, redBtn, cancelBtn, handleOtherProductsSubmit, selectedOtherProducts, unlistedotherProductsInputLabel, productsList } = props
    const [otherProducts, setOtherProducts] = useState([]);
    const getCheckedOtherProducts = (products = []) => {
        setOtherProducts(products)
    }
    return (
        <Modal show={showDialog} onClose={toggleDialog} bsClass={bsClass}>
            <ModalHeader title={modalTitle} />
            <ModalBody>
                <OtherProductsList otherProductsList={otherProductsList}
                    getCheckedOtherProducts={getCheckedOtherProducts}
                    selectedOtherProducts={selectedOtherProducts}
                    unlistedotherProductsInputLabel={unlistedotherProductsInputLabel}
                    productsList={productsList}
                ></OtherProductsList>
            </ModalBody>
            <ModalFooter>
                <button aria-label="Cancel" class="gdocs-btn-default return-btn" onClick={toggleDialog}> {cancelBtn}</button>
                <button className="gdocs-btn-primary" onClick={() => handleOtherProductsSubmit(otherProducts)}>{redBtn}</button>
            </ModalFooter>
        </Modal>
    )

}

export default OtherProductsListModal


// WEBPACK FOOTER //
// ./src/components/CaseBody/Modals/OtherProductsListModal/index.js